import * as React from 'react';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Moment from './Moment';
import MomentCreateOrUpdate from './MomentCreateOrUpdate';
import SimpleCollection from '../Organisms/SimpleCollection/';

const MomentsGrid = (props: any) => {
    const { createMoment, fetchUserAvatar, posts, removeMoment, setActiveMoment } = props;
    const [open, setOpen] = React.useState(false);

    function handleClickOpen() {
        setOpen(true);
    }

    function handleClose() {
        setOpen(false);
    }
    const handleSave = (payload: any) => {
        createMoment(payload);
        handleClose();
    };

    return (
        <React.Fragment>
            <Grid container wrap="wrap">
                <SimpleCollection
                    data={posts}
                    fabPosition="absolute"
                    fabRight={'0'}
                    itemRender={(post, idx) => {
                        return (
                            <Grid item xs>
                                <Moment
                                    onClick={()=>props.history.push(`${props.location.pathname}/${post.id}`)}
                                    fetchUserAvatar={fetchUserAvatar}
                                    post={post}
                                    remove={removeMoment}
                                    setActive={setActiveMoment}
                                />
                            </Grid>
                        );
                    }}
                    mode="dark"
                    onCreate={handleClickOpen}
                    onSort={props.updateMomentFilter}
                    type="card"
                />
            </Grid>
            <MomentCreateOrUpdate title={'Create a new moment'} handleClose={handleClose} handleSave={handleSave} open={open} />
        </React.Fragment>
    );
};

export default withRouter(MomentsGrid);
